import React from "react";
import {
  DialogMessage,
  IconNames,
  IconWithBackground
} from "@tvg/design-system";

interface Props {
  title: string;
  description: string;
  qaLabel: string;
  iconName: IconNames;
}

const EmptyCaseDialogMessage = ({
  title,
  description,
  qaLabel,
  iconName
}: Props) => (
  <DialogMessage
    qaLabel={qaLabel}
    title={title}
    description={description}
    padding="space-6"
    illustration={
      <IconWithBackground
        mainCircleBackground="blue_accent.100"
        mainIcon={{
          name: iconName,
          lineColor: "blue_accent.600",
          backgroundColor: "blue_accent.100"
        }}
      />
    }
  />
);

export default EmptyCaseDialogMessage;
